module.exports = __webpack_public_path__ + "media/images/city/062-hassan-mosque-5e052e4da1cd274fcf7e12690118db95.svg";